import { createFileRoute, Outlet } from '@tanstack/react-router'
import { RouteLayout } from '@web/app/components'
import { Building2 } from '@tamagui/lucide-icons'

export const Route = createFileRoute('/_index/admin')({
  component: RouteComponent,
  staticData: {
    metaRoute: {
      title: 'Administración',
      icon: Building2,
    },
  },
})

function RouteComponent() {
  return (
    <RouteLayout>
<Outlet />
    </RouteLayout>
  )
}
